/* eslint-disable global-require */
import MicroModal from 'micromodal';
import initSelectric from './components/selectric/selectric';
import anchors from './navigation/anchors';
import mobileHeaderNavMain from './navigation/navigation';
import mobileHeaderNav from './navigation/mobile-nav';
import externalLinks from './components/external-links/_external-links';
import consentModal from './components/consent-modal/consent';
import contactForm from './components/contact-form/contact-form';
import SingleResource from './components/single-resource/single-resource';
import FeaturedResources from './components/featured-resources/featured-resources';
import RelatedResources from './components/related-resources/related-resources';

const Site = () => {

    function mfReady(callbackFunc) {
        if (document.readyState !== 'loading') {
            // Document is already ready, call the callback directly
            callbackFunc();
        } else if (document.addEventListener) {
            // All modern browsers to register DOMContentLoaded
            document.addEventListener('DOMContentLoaded', callbackFunc);
        } else {
            // Old IE browsers
            document.attachEvent('onreadystatechange', () => {
                if (document.readyState === 'complete') {
                    callbackFunc();
                }
            });
        }
    }

    mfReady(() => {

        // Main header nav
        anchors();

        // Mobile Navigation Set-up
        mobileHeaderNavMain();

        // Mobile Navigation Set-up
        mobileHeaderNav();

        // External Links Warning
        externalLinks();

        // Consent Modal
        consentModal();

        // Contact form state handling
        contactForm();

        // Resource citation copy interaction
        SingleResource();
        
        RelatedResources();
        
        FeaturedResources();

        MicroModal.init({
            disableScroll: true,
            awaitOpenAnimation: true,
            awaitCloseAnimation: true,
        });

        initSelectric();

    });
};

export default Site;
